var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMonitorProbabilisticFlakiness = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_951_22125)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 17C15 17 15.8 16 15.8 14.2V9.99999C15.8 7.99999 16.8 6.69999 19 6.99999",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 11.2H18.7",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 10L1 17",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 7H3.5C4.88071 7 6 8.11929 6 9.5V9.5C6 10.8807 4.88071 12 3.5 12H1V7Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.745 3C9.58881 5.85953 8.99627 8.91558 8.99999 12C8.99999 15.183 9.61999 18.22 10.745 21M21.5 3C22.467 5.78 23 8.817 23 12C23 15.183 22.467 18.22 21.5 21",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_951_22125"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
export default SvgMonitorProbabilisticFlakiness;